/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum UserContextEnum {
    PNW2 = 'PNW2',
    ASCC = 'ASCC'
}
